import { insAuditLogApi } from '@/core/api/ins-audit-log'

export const {
  useGetInsAuditLogsQuery,
  useGetPatientInsAuditLogsQuery,
  useLogInsCallMutation,
} = insAuditLogApi
